/**
 * API Error types and handling
 */
export class ApiError extends Error {
    code;
    statusCode;
    details;
    constructor(code, message, statusCode, details) {
        super(message);
        this.code = code;
        this.statusCode = statusCode;
        this.details = details;
        this.name = 'ApiError';
    }
    static fromResponse(statusCode, data) {
        return new ApiError(data.code ?? 'UNKNOWN_ERROR', data.message ?? 'An unknown error occurred', statusCode, data.details);
    }
}
export class NetworkError extends Error {
    code = 'NETWORK_ERROR';
    constructor(message) {
        super(message);
        this.name = 'NetworkError';
    }
}
export class AuthenticationError extends ApiError {
    constructor(message = 'Authentication required') {
        super('AUTHENTICATION_ERROR', message, 401);
        this.name = 'AuthenticationError';
    }
}
export class AuthorizationError extends ApiError {
    constructor(message = 'Access denied') {
        super('AUTHORIZATION_ERROR', message, 403);
        this.name = 'AuthorizationError';
    }
}
export class NotFoundError extends ApiError {
    constructor(message = 'Resource not found') {
        super('NOT_FOUND', message, 404);
        this.name = 'NotFoundError';
    }
}
export class ValidationError extends ApiError {
    constructor(message, details) {
        super('VALIDATION_ERROR', message, 422, details);
        this.name = 'ValidationError';
    }
}
//# sourceMappingURL=errors.js.map